import { ClientPlan, ClientType } from '@maru44/huntre-utils/src/models/client'
import { ClientMemberRole } from '@maru44/huntre-utils/src/models/clientMember'
import { Paper, Skeleton, Stack } from '@mui/material'
import { useContext } from 'react'
import { ClientContext } from 'src/components/providers/ClientProvider'
import { ProSubscriptionPanel } from './ProSubscriptionPanel'
import { ProUpgradeNotice } from './ProUpgradeNotice'

type Props = {
  clientId: string
}

// グループに対する Pro 関連の表示を一手に担う
// - admin: Stripe の状態に応じて Panel (申込済) か UpgradeNotice (未申込) を出す
// - member: Firestore の plan が Free のときだけ案内を出す (Pro 中なら何も出さない)
// - user タイプの client では非表示
export const ProSection = ({ clientId }: Props) => {
  const { client, currentMember, proSubscription, isProSubscriptionLoading } = useContext(ClientContext)
  const isAdmin = currentMember?.role === ClientMemberRole.Admin
  const isGroup = client?.type === ClientType.Group

  if (!isGroup) return null

  if (isAdmin) {
    if (isProSubscriptionLoading) {
      return (
        <Paper elevation={3} sx={{ p: 2 }}>
          <Stack spacing={1}>
            <Skeleton variant="text" width={180} />
            <Skeleton variant="text" width={220} />
            <Skeleton variant="text" width={140} />
          </Stack>
        </Paper>
      )
    }
    if (proSubscription) {
      return <ProSubscriptionPanel clientId={clientId} />
    }
    return <ProUpgradeNotice clientId={clientId} isAdmin={true} />
  }

  // 非 admin: Firestore の plan に従う
  if (client?.plan !== ClientPlan.Pro) {
    return <ProUpgradeNotice clientId={clientId} isAdmin={false} />
  }
  return null
}
